
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RegistroPontoPhoto extends Vue {
  //#region [ CONSTANTS ]
  readonly COUNTDOWN = 3 as const;
  //#endregion



  //#region [ DATA ]
  stream: MediaStream | null = null;
  countdown: number = -1;
  photoBase64: string | null = null;
  promise: {
    resolve: (value: string | PromiseLike<string>) => void;
    reject: (reason?: any) => void;
  } | null = null;
  //#endregion



  //#region [ LIFECYCLE ]
  beforeDestroy() {
    this.stopCamera();
  }
  //#endregion



  //#region [ METHODS ]
  async startCamera() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user' },
        audio: false
      });

      const video = this.$refs.video as HTMLVideoElement;

      if (video && this.stream) {
        video.srcObject = this.stream;
      }
    } catch (err) {
      this.promise.reject(err);
      throw err;
    }
  }

  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  takePhoto(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.promise = {
        resolve,
        reject,
      };

      this.startCamera();
      this.startCountdown();
    });
  }

  startCountdown() {
    this.countdown = this.COUNTDOWN;

    const tick = () => {
      if (this.countdown > 1) {
        setTimeout(() => {
          this.countdown--;
          tick();
        }, 1000);
      } else {
        setTimeout(() => {
          this.countdown = 0;
          this.capturePhoto();
        }, 1000);
      }
    };
    tick();
  }

  showFlashEffect() {

  }

  capturePhoto() {
    const video = this.$refs.video as HTMLVideoElement;
    const canvas = this.$refs.canvas as HTMLCanvasElement;

    if (!video || !canvas) {
      if (this.promise) {
        this.promise.reject('Falha técnica: video ou canvas é undefined.');
      }

      return;
    }

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photoBase64 = canvas.toDataURL('image/png');
      this.stopCamera();

      // mostra a foto por 2 segundos antes de enviar
      setTimeout(() => {
        this.sendPhoto();
      }, 2000);
    } else {
      if (this.promise) {
        this.promise.reject('Falha técnica: não possível gerar o contexto do canvas.');
      }
    }
  }

  sendPhoto(): void {
    if (this.promise) {
      this.promise.resolve(this.photoBase64);
      this.promise = null;

      // espera 0.5s para dar tempo de trocar de tab
      setTimeout(() => {
        this.photoBase64 = null;
      }, 500);
    }
  }
  //#endregion
}
